export const UPDATE_ASSIGNMENT_TABLE = 'UPDATE_ASSIGNMENT_TABLE';
export const UPDATE_INTERVENTION_OBJECTIVES_TABLE = 'UPDATE_INTERVENTION_OBJECTIVES_TABLE';
